export default "__VITE_ASSET__C$qELclh__"